module.exports = __webpack_public_path__ + "img/small_Zloty dab ( 51).e9a469fc.png";